import { makeImmutable } from "./makeImmutable";
export const FULL_DAY = 24 * 60 * 60;
/*
 * Second of a day (between 0 and 24 * 60 * 60 seconds)
 */
export class DaySecond {
    constructor(value) {
        this.value = value;
        makeImmutable(this);
    }
    static fromNumber(value) {
        if (value < 0 || value > FULL_DAY) {
            throw new Error("Day second must be in day range");
        }
        return new DaySecond(value);
    }
    eq(other) {
        return this.value === other.value;
    }
    isAfter(other) {
        return this.value > other.value;
    }
    isBefore(other) {
        return this.value < other.value;
    }
    isBetween(from, to) {
        return from.value <= this.value && this.value <= to.value;
    }
    duration(other) {
        return Math.abs(this.value - other.value);
    }
    compare(other) {
        return this.value - other.value;
    }
    min(other) {
        return new DaySecond(Math.min(this.value, other.value));
    }
    max(other) {
        return new DaySecond(Math.max(this.value, other.value));
    }
    toString() {
        const totalMinutes = Math.round(this.value / 60);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours}:${minutes <= 10 ? "0" : ""}${minutes}`;
    }
}
DaySecond.First = new DaySecond(0);
DaySecond.Last = new DaySecond(FULL_DAY);
